"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneDynamicLogin = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var dynamicCode_1 = require("../../model/dynamicCode");
var service_1 = require("../../../library/base/service");
var PhoneDynamicLogin = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PhoneDynamicLogin, _super);
    function PhoneDynamicLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '手机动态码登录接口';
        _this.code = '101074';
        _this.desc = '手机动态码登录接口';
        _this.requestParams = new dynamicCode_1.PhoneDynamicLoginRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return PhoneDynamicLogin;
}(service_1.BaseService));
exports.PhoneDynamicLogin = PhoneDynamicLogin;
//# sourceMappingURL=phoneDynamicLogin.js.map